import rat1 from "./rat-1.jpg";
import rat2 from "./rat-2.jpg";
import rat3 from "./rat-3.jpg";
import rat4 from "./rat-4.jpg";
import rat5 from "./rat-5.jpg";
import rat6 from "./rat-6.jpg";
import rat7 from "./rat-7.jpg";
import rat8 from "./rat-8.jpg";
import rat9 from "./rat-9.jpg";
import rat10 from "./rat-10.jpg";

export const ratajeImages = [
  rat1, rat2, rat3, rat4, rat5, rat6, rat7, rat8, rat9, rat10,
];
